import _ from "lodash";
import { approvalProcessStatusDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { GeneralProposalConstant } from "presentation/constant/GeneralProposal/GeneralProposalConstant";
import { useGeneralProposalVM } from "presentation/hook/GeneralProposal/useGeneralProposalVM";
import { useGeneralProposalTracked } from "presentation/store/GeneralProposal/GeneralProposalProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

const GeneralProposalSearchForm = () => {
    const GENERAL_PROPOSAL_CONSTANT = GeneralProposalConstant.Search;
    const [generalProposalState] = useGeneralProposalTracked();
    const generalProposalVM = useGeneralProposalVM();
    const searchCriteria = generalProposalState.searchCriteria;

    const memoTariffCodeOptions = useMemo(() => {
        const groupOfTariffCodeOptions = searchCriteria.tariffTypeList?.map(tariffType => generalProposalState.dynamicOptions.tariffCodeDropdownOptions[tariffType]);
        const commonTariffCodeOptions = _.orderBy(_.uniqBy(_.flatMap(_.concat(groupOfTariffCodeOptions ?? [])), 'value'), 'dropdownLabel');
        return commonTariffCodeOptions;
    }, [searchCriteria.tariffTypeList, generalProposalState.dynamicOptions.tariffCodeDropdownOptions])

    const memoTarType = useMemo(() =>
        <div className='flex-row-item' style={{ width: "180px" }}>

            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.tariffTypeList?.join(',')}
                fieldValue={searchCriteria?.tariffTypeList}
                fieldLabel={GeneralProposalConstant.Table.TARIFF_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffTypeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={generalProposalState.dynamicOptions.tariffTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    generalProposalVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [searchCriteria.tariffTypeList, generalProposalState.dynamicOptions.tariffTypeDropdownOptions, generalProposalVM])

    const memoTarCode = useMemo(() =>
        <div className='flex-row-item' style={{ width: "180px" }}>

            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.tariffCodeList?.join(',')}
                fieldValue={searchCriteria?.tariffCodeList}
                fieldLabel={GeneralProposalConstant.Table.TARIFF_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffCodeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={memoTariffCodeOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    generalProposalVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [searchCriteria.tariffCodeList, memoTariffCodeOptions, generalProposalVM])

    const memoStatus = useMemo(() =>
        <div className='flex-row-item' style={{ width: "180px" }}>

            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.statusList?.join(',')}
                fieldValue={searchCriteria?.statusList}
                fieldLabel={GENERAL_PROPOSAL_CONSTANT.STATUS}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'statusList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={approvalProcessStatusDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    generalProposalVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [GENERAL_PROPOSAL_CONSTANT.STATUS, searchCriteria.statusList, generalProposalVM])


    const memoEffectiveDateFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={GENERAL_PROPOSAL_CONSTANT.EFFECTIVE_DATE_RANGE}
                width='390px'
                fieldNames={{ startField: "effectiveDateFrom", endField: "effectiveDateTo" }}
                dateRange={{ startDate: searchCriteria.effectiveDateFrom, endDate: searchCriteria.effectiveDateTo }}
                onDatesChange={generalProposalVM.onDateRangeChange}
            />
        </div>
        , [GENERAL_PROPOSAL_CONSTANT.EFFECTIVE_DATE_RANGE, searchCriteria.effectiveDateFrom, searchCriteria.effectiveDateTo, generalProposalVM.onDateRangeChange])

    return <>

        <CriteriaItemContainer>
            {memoTarType}
            {memoTarCode}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoStatus}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoEffectiveDateFromTo}
        </CriteriaItemContainer>

    </>;
}
export default memo(GeneralProposalSearchForm);